import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Pais } from '../model/pais';
import { Injectable } from '@angular/core';

@Injectable()
export class BLPais {

    constructor(
        private dataService: DataService,
        private http: HttpClient) {
    }

    list(language: string): Promise<Pais[]> {
        const url = 'pais?language=' + language;
        return new Promise<Pais[]>((resolve, reject) => {
            this.http.get<Pais[]>(this.dataService.getApiEndpoint(url)).subscribe(data => {
                resolve(data);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/bl/blpais.ts